import {
  MODAL_HIDDEN,
  SQL_CHECKED,
  MODAL_INTERACTION,
  LOADING,
  FAILED,
  MODAL_DATA_LOADED,
} from '../actions/constants';
import { SQL_FROM } from '../util/enums/EnumLayers';
import ModalSqlEditor from '../components/modals/ModalSqlEditor';

const INITIAL_STATE = {
  sql: '',
  errorMsg: null, // string
  checkingSql: false,
  readyForSave: false,
  isFreePlan: false,
  isHeroku: false,
  showBlurb: false,
  isExport: false,
};

function interaction(state, payload) {
  switch (payload.section) {
    case 'sqlChange':
      return {
        ...INITIAL_STATE, // reset everything
        sql: payload.sql,
        readyForSave: true,
      };
    case 'showMe':
      return { ...state, showBlurb: true };
    default:
      return state;
  }
}

const modalSqlEditor = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case LOADING: {
      if (action.awaiting === SQL_CHECKED) {
        return {
          ...state,
          checkingSql: true,
          errorMsg: null,
          readyForSave: false,
        };
      }
      return state;
    }
    case FAILED: {
      if (action.awaiting === SQL_CHECKED) {
        return {
          ...state,
          errorMsg:
            'An error occurred.  Please try again or contact us if the problem persists.',
          checkingSql: false,
          readyForSave: true, // re-enable so they can try again
        };
      }
      return state;
    }
    case MODAL_DATA_LOADED: {
      if (action.payload.modal === ModalSqlEditor) {
        if (action.payload.props.existing) {
          const sqlLayer = action.payload.props.existing;
          return { ...INITIAL_STATE, sql: sqlLayer.sql() };
        }
        if (action.payload.props.searchedSql) {
          return {
            ...INITIAL_STATE,
            sql: action.payload.props.searchedSql,
            readyForSave: !action.payload.props.isExport,
            isExport: action.payload.props.isExport,
          };
        }
        if (action.payload.isFreePlan) {
          return {
            ...INITIAL_STATE, // isFreePlan: true,
            // showBlurb: true,
            isHeroku: action.payload.isHeroku,
          };
        }
      }
      return state;
    }
    case SQL_CHECKED: {
      return {
        ...state,
        errorMsg: action.payload.json._errorMsg,
        checkingSql: false,
      };
    }
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== SQL_FROM) {
        return state;
      }
      return interaction(state, action.payload.props);
    }
    default:
      return state;
  }
};

export default modalSqlEditor;
